const SkillCompleting = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask
        id="mask0_188_2552"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="12"
        y="0"
        width="11"
        height="15"
      >
        <path
          d="M22.0818 3.97546C22.6989 2.90656 22.3327 1.53975 21.2638 0.922622C20.1949 0.30549 18.8281 0.671724 18.211 1.74063L12.6239 11.4177L12.8059 14.2408C12.8427 14.8105 13.4471 15.1594 13.9589 14.9064L16.4947 13.6526L22.0818 3.97546Z"
          fill="#F23B3B"
        />
      </mask>
      <g mask="url(#mask0_188_2552)">
        <rect
          x="20.127"
          y="7.3623"
          width="2.79354"
          height="1.11742"
          transform="rotate(-150 20.127 7.3623)"
          fill="#D9CCB9"
        />
        <rect
          x="20.6855"
          y="6.39551"
          width="2.79354"
          height="1.11742"
          transform="rotate(-150 20.6855 6.39551)"
          fill="#F7F3F0"
        />
        <rect
          x="17.707"
          y="5.96582"
          width="1.67613"
          height="1.11742"
          transform="rotate(-150 17.707 5.96582)"
          fill="#C6C6C6"
        />
        <rect
          x="18.2656"
          y="4.99805"
          width="1.67613"
          height="1.11742"
          transform="rotate(-150 18.2656 4.99805)"
          fill="#DDDDDD"
        />
        <path
          d="M22.0818 3.97546C22.6989 2.90656 22.3327 1.53975 21.2638 0.922622C20.1949 0.30549 18.8281 0.671724 18.211 1.74063L17.3729 3.1922L21.2437 5.42703L22.0818 3.97546Z"
          fill="#F29090"
        />
        <path
          d="M21.748 1.20215L19.3288 -0.194623L17.3733 3.19237L18.8249 4.03043C18.8249 4.03043 19.5232 2.82079 19.9423 2.09501C20.501 1.1273 21.748 1.20215 21.748 1.20215Z"
          fill="#E33434"
        />
        <path d="M20.127 7.3623L17.7077 5.96553L14.0761 12.2557L16.4953 13.6524L20.127 7.3623Z" fill="#FFCC5B" />
        <path d="M17.707 5.96582L16.2555 5.12776L12.6239 11.4179L14.0754 12.2559L17.707 5.96582Z" fill="#FDBC4B" />
        <path d="M16.4958 13.6528L12.625 11.418L12.8843 15.4385L16.4958 13.6528Z" fill="#F4CF9D" />
        <path d="M12.8843 15.4385L14.1688 14.8898L14.0766 12.256L12.625 11.418L12.8843 15.4385Z" fill="#EEBF86" />
        <path d="M14.6893 14.5461L12.7539 13.4287L12.8836 15.439L14.6893 14.5461Z" fill="#51504E" />
      </g>
      <path
        d="M7.98686 4.08377C8.28529 3.97809 8.74231 3.91634 9.10554 4.21988L9.17692 4.28516L9.22084 4.33378C9.31506 4.44753 9.35439 4.56413 9.37183 4.63032C9.39334 4.71207 9.39915 4.78476 9.40066 4.83311C9.40365 4.92957 9.3929 5.02313 9.38213 5.09492C9.35973 5.24416 9.31705 5.4247 9.26614 5.61647C9.1627 6.00612 8.99991 6.53185 8.80494 7.13668C8.40926 8.36417 7.87869 9.92925 7.3733 11.5376C6.86909 13.1421 6.40717 14.7374 6.15716 15.9808C6.06494 16.4395 6.00563 16.8308 5.98078 17.1462C6.02723 17.0836 6.07676 17.0156 6.12834 16.9413C6.60789 16.2503 7.18382 15.2285 7.80087 14.0912C8.40914 12.9701 9.05457 11.7415 9.65253 10.6938C10.2385 9.66716 10.8306 8.71762 11.3457 8.19645C11.3756 8.1662 11.418 8.1259 11.4699 8.08742C11.5068 8.06 11.62 7.97795 11.7849 7.94644C11.8784 7.92859 12.0153 7.92229 12.1658 7.97769C12.3239 8.03592 12.4406 8.1418 12.5158 8.25479C12.6421 8.44479 12.6417 8.63628 12.6414 8.68467C12.6405 8.81547 12.6075 8.936 12.5913 8.99301C12.5697 9.06926 12.5406 9.1527 12.5096 9.23747C12.388 9.56984 12.1639 10.0909 11.8926 10.7139C11.3413 11.9803 10.5588 13.7525 9.86323 15.578C9.16312 17.4156 8.57431 19.2496 8.38835 20.6449C8.2943 21.3508 8.3157 21.8629 8.41855 22.186C8.49463 22.4248 8.59464 22.5211 8.74317 22.5638C8.7974 22.5279 8.88774 22.4502 9.01083 22.2992C9.27041 21.9807 9.57093 21.4751 9.91607 20.8033C10.257 20.1397 10.6207 19.357 11.0142 18.5052C11.4053 17.6586 11.8239 16.7478 12.2681 15.8489C12.4416 15.4976 12.8639 15.3552 13.211 15.5308C13.5581 15.7064 13.6988 16.1331 13.5254 16.4843C13.0911 17.3632 12.6806 18.256 12.2873 19.1074C11.8963 19.9536 11.52 20.764 11.1631 21.4589C10.8104 22.1455 10.4542 22.7636 10.0952 23.2041C9.91576 23.4242 9.70902 23.634 9.47135 23.7819C9.22668 23.934 8.90996 24.0431 8.55444 23.9777C7.77205 23.8338 7.29589 23.2988 7.08025 22.6214C6.88126 21.996 6.8916 21.2326 6.99515 20.4553C7.14539 19.3278 7.51953 17.9974 7.97863 16.6517C7.73493 17.0633 7.50012 17.4395 7.27859 17.7587C7.01805 18.1341 6.74406 18.4802 6.46943 18.7115C6.33325 18.8262 6.15171 18.9514 5.93274 19.0136C5.68794 19.0831 5.3934 19.0706 5.1277 18.8914C4.85092 18.7046 4.71781 18.4248 4.6514 18.1969C4.58388 17.9652 4.5619 17.7105 4.5615 17.4628C4.5607 16.9656 4.6476 16.354 4.77974 15.6968C5.04584 14.3735 5.52764 12.7165 6.03363 11.1063C6.53848 9.49969 7.08474 7.88682 7.4687 6.69569C7.55246 6.43585 7.62704 6.196 7.69381 5.97969C7.06877 6.56907 6.18741 7.63822 5.05632 9.43678C3.83663 11.3762 3.27408 12.6283 3.0825 13.4425C2.98861 13.8417 2.9936 14.098 3.02691 14.2606C3.05768 14.4106 3.11828 14.5107 3.20329 14.5967C3.47774 14.8745 3.47774 15.3253 3.20329 15.603C2.92886 15.8805 2.4839 15.8805 2.20952 15.603C1.94332 15.3337 1.7409 14.9888 1.65086 14.5502C1.56343 14.1239 1.58975 13.6465 1.71537 13.1126C1.96307 12.0601 2.63051 10.6451 3.87038 8.67356C5.11648 6.6921 6.12492 5.47262 6.89975 4.78658C7.28304 4.44721 7.64699 4.20414 7.98686 4.08377Z"
        fill="#51504E"
      />
    </svg>
  );
};
export default SkillCompleting;
